import { NgModule } from '@angular/core';
import {
  RouterModule,
  Routes,
} from '@angular/router';
import { RoleGuard } from './core/auth/role.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import(
        './authentication/authentication-module'
      ).then(
        (module) =>
          module.AuthenticationModule
      ),
  },
  {
    path: 'admin',
    canActivate: [RoleGuard],
    data: {
      roles: ['ADMIN'],
    },
    loadChildren: () =>
      import(
        './layouts/admin-layout/adminlayout-module'
      ).then(
        (module) =>
          module.AdminLayoutModule
      ),
  },
  {
    path: 'organization',
    canActivate: [RoleGuard],
    data: {
      roles: ['ORGANIZATION'],
    },
    loadChildren: () =>
      import(
        './layouts/organization-layout/organizationlayout-module'
      ).then(
        (module) =>
          module.OrganizationLayoutModule
      ),
  },
  {
    path: 'instructor',
    canActivate: [RoleGuard],
    data: {
      roles: ['INSTRUCTOR'],
    },
    loadChildren: () =>
      import(
        './layouts/instructor-layout/instructorlayout-module'
      ).then(
        (module) =>
          module.InstructorLayoutModule
      ),
  },
  {
    path: 'affiliator',
    canActivate: [RoleGuard],
    data: {
      roles: ['AFFILIATOR'],
    },
    loadChildren: () =>
      import(
        './layouts/affiliator-layout/affiliatorlayout-module'
      ).then(
        (module) =>
          module.AffiliatorLayoutModule
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import(
        './landing/landing-module'
      ).then(
        (module) =>
          module.LandingModule
      ),
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [
    RouterModule,
  ],
})
export class AppRoutingModule {}
